import { containerApi } from '../..'
import type { WallpaperAnimationResponse } from '../getAllDesktopSettings/getAllDesktopSettings.types'

export const getPredefinedWallpaperAnimation = async (wallpaperId: string) => {
  const response = await containerApi.get<{
    data: WallpaperAnimationResponse
  }>(
    `/desktop/wallpapers/predefined/${encodeURIComponent(wallpaperId)}/animation`
  )
  return response.data.data
}
